import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, defineProperty as _defineProperty, assertThisInitialized as _assertThisInitialized, createClass as _createClass, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import _pt from '../../node_modules/prop-types/index.js';
import React from 'react';
import ModalBase$1 from './base/ModalBase.js';
import ModalFormBase$1 from './base/ModalFormBase.js';

var _excluded = ["withForm", "renderTrigger", "onSubmitted", "onCancelled", "renderModal"],
    _excluded2 = ["withForm", "renderTrigger", "onSubmitted", "onCancelled", "renderModal"];
/**
 * A helper to load and save data, and manage state for a modal
 */

var ModalBuilder = /*#__PURE__*/function (_React$Component) {
  _inherits(ModalBuilder, _React$Component);

  var _super = _createSuper(ModalBuilder);

  function ModalBuilder() {
    var _this;

    _classCallCheck(this, ModalBuilder);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      active: false
    });

    _defineProperty(_assertThisInitialized(_this), "showModal", function () {
      return _this.setState({
        active: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "submitModal", function (response, params, state) {
      var _state$options;

      if (!(state !== null && state !== void 0 && (_state$options = state.options) !== null && _state$options !== void 0 && _state$options.keepOpen)) {
        _this.setState({
          active: false
        });
      }

      var onSubmitted = _this.props.onSubmitted;
      if (onSubmitted) onSubmitted(response, params, state);
    });

    _defineProperty(_assertThisInitialized(_this), "cancelModal", function () {
      _this.setState({
        active: false
      });

      var onCancelled = _this.props.onCancelled;
      if (onCancelled) onCancelled();
    });

    _defineProperty(_assertThisInitialized(_this), "modalWithData", function () {
      var _ref = _this.props;
      _ref.withForm;

      var renderTrigger = _ref.renderTrigger,
          onSubmitted = _ref.onSubmitted,
          onCancelled = _ref.onCancelled,
          renderModal = _ref.renderModal,
          otherProps = _objectWithoutProperties(_ref, _excluded);

      return /*#__PURE__*/React.createElement(ModalBase$1, _extends({}, otherProps, {
        onSubmitted: renderTrigger ? _this.submitModal : onSubmitted,
        onCancelled: renderTrigger ? _this.cancelModal : onCancelled,
        render: renderModal
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "modalWithForm", function () {
      var _ref2 = _this.props;
      _ref2.withForm;

      var renderTrigger = _ref2.renderTrigger,
          onSubmitted = _ref2.onSubmitted,
          onCancelled = _ref2.onCancelled,
          renderModal = _ref2.renderModal,
          otherProps = _objectWithoutProperties(_ref2, _excluded2);

      return /*#__PURE__*/React.createElement(ModalFormBase$1, _extends({}, otherProps, {
        onSubmitted: renderTrigger ? _this.submitModal : onSubmitted,
        onCancelled: renderTrigger ? _this.cancelModal : onCancelled,
        render: renderModal
      }));
    });

    return _this;
  }

  _createClass(ModalBuilder, [{
    key: "render",
    value: function render() {
      var active = this.state.active;
      var _this$props = this.props,
          withForm = _this$props.withForm,
          renderTrigger = _this$props.renderTrigger;
      var modal = withForm ? this.modalWithForm() : this.modalWithData();

      if (renderTrigger) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, renderTrigger(this.showModal), active && modal);
      }

      return modal;
    }
  }]);

  return ModalBuilder;
}(React.Component);

_defineProperty(ModalBuilder, "propTypes", {
  submitAction: _pt.func,
  onSubmit: _pt.func,
  withForm: _pt.any,
  renderTrigger: _pt.func,
  renderModal: _pt.func.isRequired,
  visible: _pt.bool,
  initialData: _pt.any,
  loadAction: _pt.func,
  loadParams: _pt.any,
  loadTransform: _pt.func,
  loadSlowDelay: _pt.number,
  onLoad: _pt.func,
  onLoaded: _pt.func,
  submitParams: _pt.any,
  submitSlowDelay: _pt.number,
  onSubmitted: _pt.func,
  isDirtyChange: _pt.func,
  onCancel: _pt.func,
  onCancelled: _pt.func,
  preventErrorNotification: _pt.bool,
  abortSubmitOnCancel: _pt.bool
});

_defineProperty(ModalBuilder, "defaultProps", {
  withForm: false,
  visible: true,
  loadTransform: function loadTransform(data) {
    return data;
  },
  loadSlowDelay: 200,
  submitSlowDelay: 200,
  isDirtyChange: function isDirtyChange() {
    return true;
  },
  initialData: {},
  preventErrorNotification: true,
  abortSubmitOnCancel: true
});

var ModalBuilder$1 = ModalBuilder;

export { ModalBuilder$1 as default };
